// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"e3d56cc9","533":"9c21c73d"}[chunkId] + ".chunk.js";
};